function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Subscription } from "@apollo/client/react/components";
import flagEnabled from "sprout-lib/dist/flags";
const NullSubscription = ()=>null;
const SubscriptionNoSSR = Object.assign((props)=>{
    const [mounted, setMounted] = useState(false);
    useEffect(()=>setMounted(true), []);
    if (mounted) return /*#__PURE__*/ _jsx(Subscription, _objectSpread({}, props));
    else return null;
}, Subscription);
const FeatureFlaggedSubscription = flagEnabled("SUBSCRIPTIONS") ? SubscriptionNoSSR : NullSubscription;
export default FeatureFlaggedSubscription;
